import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class NotificationService {

  constructor(
    private translateService: TranslateService,
    private toastrService: ToastrService
  ) {
  }

  public showSuccess(messageName: string, params?: any) {
    this.translateService.get(messageName, params).subscribe(
    (message) => {
      this.toastrService.success(message);
    });
  }

  public showFailure(messageName: string, params?: any) {
    this.translateService.get(messageName, params).subscribe(
    (message) => {
      this.toastrService.error(message);
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/notification.service.ts